import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  AdherentParticulierResponse,
  AdhesionAdherentParticulierResponse,
  CompteParticulierResponse,
} from "../../services/Api/swagger";

export interface AdherentState {
  infoCompte?: CompteParticulierResponse;
  listeAdherents?: AdherentParticulierResponse[];
  listeAdhesions?: AdhesionAdherentParticulierResponse[];
}

const initialState: AdherentState = {};

export const AdherentSlice = createSlice({
  name: "@@app/adherent",
  initialState: initialState,
  reducers: {
    setCompte: (
      state: AdherentState,
      action: PayloadAction<CompteParticulierResponse | undefined>
    ) => {
      state.infoCompte = action.payload;
    },
    setListeAdherents: (
      state: AdherentState,
      action: PayloadAction<AdherentParticulierResponse | undefined>
    ) => {
      if (action.payload) {
        const listAdhesion = action.payload.listAdhesion || [];
        state.listeAdherents = state.listeAdherents
          ? [...state.listeAdherents, action.payload]
          : [action.payload];
        state.listeAdhesions = state.listeAdhesions
          ? [...state.listeAdhesions, ...listAdhesion]
          : [...listAdhesion];
      } else {
        state.listeAdherents = undefined;
        state.listeAdhesions = undefined;
      }
    },
    setAdhesionMandat: (state: AdherentState, action: PayloadAction<any>) => {
      const findAdhesion:
        | AdhesionAdherentParticulierResponse
        | undefined = state.listeAdhesions?.find(
        (adhesion) => adhesion.numeroAdhesion === action.payload.numeroAdhesion
      );
      const adhesionWithMandat:
        | AdhesionAdherentParticulierResponse
        | undefined = findAdhesion && {
        ...findAdhesion,
        mandat: { iban: action.payload.iban, bic: action.payload.bic },
      };
      const filtersListeAdhesions = state.listeAdhesions?.filter(
        (adhesion) => adhesion.numeroAdhesion !== action.payload.numeroAdhesion
      );
      if (filtersListeAdhesions && adhesionWithMandat) {
        state.listeAdhesions = [...filtersListeAdhesions, adhesionWithMandat];
      } else if (!filtersListeAdhesions && adhesionWithMandat) {
        state.listeAdhesions = [adhesionWithMandat];
      }
    },
  },
});

export const {
  setListeAdherents,
  setCompte,
  setAdhesionMandat,
} = AdherentSlice.actions;

// Selectors
export const getListeAdherents = (
  state
): AdherentParticulierResponse[] | undefined =>
  state.adherent && state.adherent.listeAdherents;

// Selectors
export const getListeAdhesions = (
  state
): AdhesionAdherentParticulierResponse[] | undefined =>
  state.adherent && state.adherent.listeAdhesions;

export const getCompteParticulier = (
  state
): CompteParticulierResponse | undefined =>
  state.adherent && state.adherent.infoCompte;
